import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  class: "textbox__asterisk",
  "aria-hidden": "true"
}, "*", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "sr-only" }, "(required)", -1)
const _hoisted_3 = ["disabled", "readonly", "required"]
const _hoisted_4 = {
  key: 0,
  class: "textbox__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["textbox", _ctx.required ? 'textbox--required' : null])
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.hideLabel ? 'sr-only' : null)
    }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_1,
            _hoisted_2
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("span", {
      class: _normalizeClass(["textbox__entry textbox__icon pl-0", [_ctx.status ? 'textbox--' + _ctx.status : '']])
    }, [
      _withDirectives(_createElementVNode("input", {
        class: "textbox__input",
        disabled: _ctx.disabled,
        readonly: _ctx.readonly,
        required: _ctx.required,
        type: "date",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputDate) = $event)),
        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
        onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
        onkeydown: "return false"
      }, null, 40, _hoisted_3), [
        [_vModelText, _ctx.inputDate]
      ])
    ], 2),
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true)
  ], 2))
}